


























import { Component, Vue } from "vue-property-decorator";
import CardDaftarPasienBankDarah from "@/components/bank-darah/CardDaftarPasienBankDarah.vue";
import CardDaftarOrderBankDarah from "@/components/bank-darah/CardDaftarOrderBankDarah.vue";
import ListPasienTransferInternal from "@/components/pti/ListPasienTransferInternal.vue";
import PembatalanSvc from "@/services/PembatalanKomponenDarah";

@Component({
  components: {
    CardDaftarPasienBankDarah,
    CardDaftarOrderBankDarah,
    ListPasienTransferInternal
  }
})
export default class OrderBankDarahPage extends Vue {
  pembatalanMenunggu = 0;

  mounted() {
    this.$root.$on("reload-ranap-global", this.muatUlangDaftarPasien);
    this.muatPembatalan();
  }

  async muatPembatalan() {
    try {
      this.pembatalanMenunggu = await PembatalanSvc.count();
    } catch {
      this.pembatalanMenunggu = 0;
    }
  }

  beforeDestroy() {
    this.$root.$off("reload-ranap-global", this.muatUlangDaftarPasien);
  }

  muatUlangOrder() {
    const kartu = this.$refs.daftarOrder as unknown as { muat: (senyap?: boolean) => void } | undefined;
    if (kartu) kartu.muat(true);
    this.muatPembatalan();
  }

  muatUlangDaftarPasien() {
    const kartu = this.$refs.daftarPasien as unknown as { muat: () => void } | undefined;
    if (kartu) kartu.muat();
    this.muatPembatalan();
  }
}
